const KEY = "rugscan_recent_scans_v2";
const MAX = 20;

export function loadRecent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.slice(0, MAX) : [];
  } catch {
    return [];
  }
}

export function saveRecent(entry) {
  if (!entry || !entry.mint) return;
  const list = loadRecent().filter((e) => e.mint !== entry.mint);
  list.unshift({
    mint: entry.mint,
    chain: entry.chain || "solana",
    name: entry.name || "",
    symbol: entry.symbol || "",
    logo: entry.logo || "",
    score: entry.score ?? null,
    label: entry.label || "",
    ts: Date.now(),
  });
  localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
}

export function clearRecent() {
  localStorage.removeItem(KEY);
}
